import {
  COMPLIANCE_MESSAGE_FOOTER,
  MARKIT_PRIVACY_POLICY,
  MARKIT_TERMS_OF_USE,
} from "@markit/common.utils";
import { Colors } from "../../utils/colors";
import CustomCheckbox from "../CustomCheckbox";
import { useTheme } from "../../hooks/useTheme";
import { ThemeType, TwilioPhoneType } from "@markit/common.types";

type CompliancePhoneOptInProps = {
  isChecked: boolean;
  setIsChecked: (isChecked: boolean) => void;
  hostShowComplianceCheckbox?: boolean;
  hostName?: string; // if exists
  hostPhoneType: TwilioPhoneType;
  disabled?: boolean; // after verifying number
  themeType?: ThemeType;
};

const CompliancePhoneOptIn = (props: CompliancePhoneOptInProps) => {
  const {
    isChecked,
    setIsChecked,
    hostName,
    hostPhoneType,
    disabled,
    hostShowComplianceCheckbox,
    themeType,
  } = props;
  const { theme } = useTheme(themeType);

  const styles = {
    optInText: { fontSize: 10, color: Colors.GRAY2 },
  };

  return (
    <div className="AlignedRow" style={{ gap: 10 }}>
      {hostShowComplianceCheckbox ? (
        <CustomCheckbox
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
          sx={{ padding: 0 }}
          altColor={Colors.BLACK}
          disabled={disabled}
        />
      ) : null}
      <div className="ColumnNormal" style={{ gap: 5 }}>
        <p style={styles.optInText}>
          {"By continuing, you agree to our "}
          <span
            style={{
              ...theme.LinkColor,
              cursor: "pointer",
            }}
            onClick={() => {
              window.open(MARKIT_TERMS_OF_USE);
            }}
          >
            Terms
          </span>
          {" and "}
          <span
            style={{ ...theme.LinkColor, cursor: "pointer" }}
            onClick={() => window.open(MARKIT_PRIVACY_POLICY)}
          >
            Privacy Policy
          </span>
        </p>
        <p style={styles.optInText}>
          {hostShowComplianceCheckbox
            ? `I agree to receive ${
                hostPhoneType === TwilioPhoneType.TOLL_FREE
                  ? "account notifications and updates"
                  : "marketing or promotional messages via SMS"
              } from ${hostName} using Markit's automated messaging platform. ` +
              COMPLIANCE_MESSAGE_FOOTER
            : `By providing your phone number, you agree to receive recurring marketing texts ${
                hostName
                  ? `sent by ${hostName} using Markit's automated messaging platform`
                  : "sent using Markit's automated messaging platform"
              }, and you agree to our data policies. ${COMPLIANCE_MESSAGE_FOOTER}`}
        </p>
      </div>
    </div>
  );
};

export default CompliancePhoneOptIn;
